<template>
	<iframe
		:src="url"
		allowfullscreen>
	</iframe>
</template>

<script>
	import { mapState } from 'vuex'

	export default {
		computed: {
			...mapState('tours', ['ready', 'tour360']),
			url () {
				return this.tour360 && `${this.tour360.iguideUrl}?unbranded`
			}
		}
	}
</script>
